import { Typography } from '@mui/material';

/**
 * The note under a field whose value the device only suggests, so it cannot
 * be mistaken for one somebody chose. `hint` says where the suggestion came
 * from and when it is saved.
 */
export default function SuggestionNote({
    label,
    hint,
}: {
    label: string;
    hint: string;
}) {
    return (
        <Typography
            component="div"
            title={hint}
            sx={{
                mt: 0.5,
                fontSize: 11,
                lineHeight: 1.3,
                fontStyle: 'italic',
                color: 'text.secondary',
            }}
        >
            {label}
        </Typography>
    );
}
